import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const sectionTitleStyle = {
  fontWeight: 700,
  color: "#334155",
  fontSize: "15px",
  marginBottom: "14px",
};

const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: "1px solid #e2e8f0",
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const greenBtnStyle = {
  background: "#10b981",
  color: "#fff",
  border: "none",
  padding: "8px 16px",
  borderRadius: "6px",
  fontWeight: 600,
  fontSize: "14px",
  cursor: "pointer",
};

const tableHeaderStyle = {
  backgroundColor: "#f1f5f9",
  color: "#334155",
  fontWeight: 600,
  fontSize: "14px",
  padding: "12px",
};

const emptyMessageStyle = {
  textAlign: "center",
  padding: "24px",
  color: "#ea580c",
  fontSize: "14px",
};

export default function ModelPortfolios() {
  const [modelSearch, setModelSearch] = useState("");
  const [clientType, setClientType] = useState("prospect"); // "client" | "family-head" | "prospect"
  const [period, setPeriod] = useState("5-yr");

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Model Portfolio</h5>
            </div>
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/portfolio/comprehensive">Portfolio Management</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Model Portfolio
                </li>
              </ol>
            </nav>
          </div>

          {/* Section 1: Model Portfolio */}
          <div style={cardStyle}>
            <div style={sectionTitleStyle}>Model Portfolio</div>
            <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
              <input
                type="text"
                placeholder="Search Model Name"
                value={modelSearch}
                onChange={(e) => setModelSearch(e.target.value)}
                style={{ ...inputStyle, maxWidth: 320 }}
              />
              <NavLink to="/admin/portfolio/model/new" style={{ ...greenBtnStyle, textDecoration: "none", display: "inline-flex" }}>
                New Model Portfolio
              </NavLink>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                <thead>
                  <tr>
                    <th style={{ ...tableHeaderStyle, width: 60 }}>Select</th>
                    <th style={tableHeaderStyle}>Model Name</th>
                    <th style={tableHeaderStyle}>Benchmark</th>
                    <th style={tableHeaderStyle}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={4} style={emptyMessageStyle}>
                      <span className="me-2" aria-hidden>⚠</span>
                      No data available.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Section 2: Client Portfolio */}
          <div style={cardStyle}>
            <div style={sectionTitleStyle}>Client Portfolio</div>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
              <div className="d-flex gap-3">
                {[
                  { value: "client", label: "Client" },
                  { value: "family-head", label: "Family Head" },
                  { value: "prospect", label: "Prospect" },
                ].map(({ value, label }) => (
                  <label key={value} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input
                      type="radio"
                      name="clientType"
                      checked={clientType === value}
                      onChange={() => setClientType(value)}
                      style={{ accentColor: "#10b981" }}
                    />
                    {label}
                  </label>
                ))}
              </div>
              <div className="d-flex gap-2">
                <button type="button" style={greenBtnStyle} className="d-flex align-items-center gap-2">
                  <i className="fa fa-download" />
                  Portfolio Analysis
                </button>
                <NavLink to="/admin/portfolio/client/new" style={{ ...greenBtnStyle, textDecoration: "none", display: "inline-flex" }}>
                  New Client Portfolio
                </NavLink>
              </div>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                <thead>
                  <tr>
                    <th style={{ ...tableHeaderStyle, width: 60 }}>Select</th>
                    <th style={tableHeaderStyle}>
                      <span className="me-1">Client Name</span>
                      <i className="fa fa-search" style={{ fontSize: "12px", color: "#64748b" }} />
                    </th>
                    <th style={tableHeaderStyle}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={3} style={emptyMessageStyle}>
                      <span className="me-2" aria-hidden>⚠</span>
                      No data available.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Section 3: Period */}
          <div style={cardStyle}>
            <div style={sectionTitleStyle}>Period</div>
            <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
              <div className="d-flex align-items-center" style={{ minWidth: 120 }}>
                <span
                  className="d-flex align-items-center justify-content-center bg-light rounded-start"
                  style={{
                    padding: "8px 10px",
                    border: "1px solid #e2e8f0",
                    borderRight: "none",
                    color: "#64748b",
                  }}
                >
                  <i className="fa fa-bars" />
                </span>
                <select
                  value={period}
                  onChange={(e) => setPeriod(e.target.value)}
                  style={{
                    ...inputStyle,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    minWidth: 100,
                  }}
                >
                  <option value="1-yr">1 Yr</option>
                  <option value="3-yr">3 Yr</option>
                  <option value="5-yr">5 Yr</option>
                  <option value="10-yr">10 Yr</option>
                </select>
              </div>
              <div className="d-flex gap-2">
                <button type="button" style={greenBtnStyle}>
                  Compare With Model
                </button>
                <button type="button" style={greenBtnStyle} className="d-flex align-items-center gap-2">
                  <i className="fa fa-download" />
                  Download Portfolio Comparison
                </button>
              </div>
            </div>
            <div style={emptyMessageStyle}>
              <span className="me-2" aria-hidden>⚠</span>
              No data available.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
